// import axios from "axios";
// import config from "react-global-configuration";

// const api = axios.create({
//   headers: {
//     'Content-Type': 'application/json',
//     'Accept': 'application/json',
//   },
// });

// api.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem('token');
//     if (token) {
//       config.headers['Authorization'] = `Bearer ${token}`;
//       config.headers['operator_id'] = 1;
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// export default api;

import axios from "axios";
import config from "react-global-configuration";

let isRefreshing = false;
let failedQueue = [];

export const userService = {
    refreshAccessToken
}

const api = axios.create({
  // baseURL: config.get("apiUrl"), // base url add kar do
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Failed requests ko retry karne ke liye queue
const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

// Request interceptor
api.interceptors.request.use(
  (cfg) => {
    const token = localStorage.getItem("token");
    if (token) {
      cfg.headers["Authorization"] = `Bearer ${token}`;
      cfg.headers["operator_id"] = 1;
    }
    return cfg;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const originalRequest = error.config;

     if (
      error.response &&
      error.response.status === 401 &&
      error.response.data?.logout === true
    ) {
      logoutUser();
      window.location.href = "/?login";
      return Promise.reject(error);
    }

    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        // Refresh chal raha hai → request ko queue me daal do
        return new Promise((resolve, reject) => {
          failedQueue.push({
            resolve: (token) => {
              originalRequest.headers["Authorization"] = "Bearer " + token;
              resolve(api(originalRequest));
            },
            reject: (err) => reject(err),
          });
        });
      }

      // Refresh start
      originalRequest._retry = true;
      isRefreshing = true;

      return refreshAccessToken()
        .then((res) => {
          const newToken = res.token;
          const newRefresh = res.refresh_token;

          localStorage.setItem("token", newToken);
          localStorage.setItem("refreshtoken", newRefresh);

          api.defaults.headers["Authorization"] = "Bearer " + newToken;
          processQueue(null, newToken);

          originalRequest.headers["Authorization"] = "Bearer " + newToken;
          return api(originalRequest);
        })
        .catch((err) => {
          processQueue(err, null);
          logoutUser();
           window.location.href = "/?login";
          return Promise.reject(err);
        })
        .finally(() => {
          isRefreshing = false;
        });
    }

    return Promise.reject(error);
  }
);

// Refresh token API
function refreshAccessToken() {
  const refreshtoken = localStorage.getItem("refreshtoken");
  return axios
    .post(`${config.get("apiUrl")}/refresh-token`, {
      refresh_token: refreshtoken,
    })
    .then((res) => res.data);
}

// Logout
function logoutUser() {
  localStorage.removeItem("user");
  localStorage.removeItem("token");
  localStorage.removeItem("refreshtoken");
  localStorage.removeItem("gameData");
  // window.location.href = "/?login";
}

export default api;
